import {useState} from "react";
import {Menu, X} from "lucide-react";
import logo from '../assets/dentotek-logo.webp';

function Navbar() {
    const [isOpen, setIsOpen] = useState(false);

    const handleRegisterClick = () => {
        window.open(process.env.REACT_APP_REGISTER_URL, '_blank');
    };

    const handleLoginClick = () => {
        window.open(process.env.REACT_APP_LOGIN_URL, '_blank');
    };

    return (
        <nav className="fixed top-0 w-full bg-white/80 backdrop-blur-md z-50 border-b border-slate-100">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between h-20 items-center">
                    <div className="flex items-center gap-2">
                        <a href={"/"}>
                            <img src={logo} alt="" width={'180px'} height={'40px'}/>
                        </a>
                    </div>

                    <div className="hidden md:flex items-center space-x-8 font-medium text-slate-600">
                        <a href="#features" className="hover:text-[#4154f1] transition-colors">Fonctionnalités</a>
                        <a href="#preview" className="hover:text-[#4154f1] transition-colors">Aperçu</a>
                        <a href="#how-it-works" className="hover:text-[#4154f1] transition-colors">Comment ça marche</a>
                        <a href="#faq" className="hover:text-[#4154f1] transition-colors">FAQ</a>
                        <button onClick={handleLoginClick} className="font-bold text-gray-900 hover:text-[#4154f1]">
                            Se connecter
                        </button>
                        <button onClick={handleRegisterClick} className="bg-primary text-white px-6 py-2.5 rounded-full hover:bg-blue-700 transition-all shadow-md shadow-blue-100">
                            Créer mon cabinet
                        </button>
                    </div>

                    <div className="md:hidden">
                        <button onClick={() => setIsOpen(!isOpen)} className="text-slate-600">
                            {isOpen ? <X size={28} /> : <Menu size={28} />}
                        </button>
                    </div>
                </div>
            </div>

            {/* Mobile Menu */}
            {isOpen && (
                <div className="md:hidden bg-white border-b border-slate-100 p-4 space-y-4 animate-in slide-in-from-top duration-300">
                    <a href="#features" className="block text-slate-600 font-medium py-2" onClick={() => setIsOpen(false)}>Fonctionnalités</a>
                    <a href="#preview" className="block text-slate-600 font-medium py-2" onClick={() => setIsOpen(false)}>Aperçu</a>
                    <a href="#how-it-works" className="block text-slate-600 font-medium py-2" onClick={() => setIsOpen(false)}>Comment ça marche</a>
                    <a href="#faq" className="block text-slate-600 font-medium py-2" onClick={() => setIsOpen(false)}>FAQ</a>
                    <button onClick={() => {
                                setIsOpen(false);
                                handleLoginClick();
                            }}
                            className="w-full text-primary px-6 py-3 rounded-xl font-bold border">
                        Se connecter
                    </button>
                    <button onClick={() => {
                                setIsOpen(false);
                                handleRegisterClick();
                            }}
                        className="w-full bg-primary text-white px-6 py-3 rounded-xl font-bold">
                        Créer mon cabinet
                    </button>
                </div>
            )}
        </nav>
    );
}

export default Navbar;